import React, { InputHTMLAttributes, ReactNode, forwardRef } from 'react';
import Input from '../Input/Input';
import styles from './InputWithLabel.module.css';

interface InputWithLabelProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    infoTooltip?: string;
    labelRight?: ReactNode;
    error?: string; // Expect error message string
    icon?: ReactNode;
    iconRight?: ReactNode;
    containerClassName?: string;
    labelClassName?: string;
}

const InputWithLabel = forwardRef<HTMLInputElement, InputWithLabelProps>(({
    label,
    infoTooltip,
    labelRight,
    error,
    id,
    disabled,
    icon,
    iconRight,
    containerClassName,
    labelClassName,
    ...inputProps
}, ref) => {
    return (
        <label className={`${styles.fieldGroup} ${disabled ? styles.disabled : ''} ${containerClassName || ''}`}>
            <div className={styles.labelRow}>
                <span className={`${styles.labelText} ${labelClassName || ''}`}>{label}</span>
                {/* {infoTooltip && (
                    <span title={infoTooltip} style={{ cursor: 'help' }}>ℹ️</span>
                )} */}
                {labelRight}
            </div>
            <div className={styles.inputWrapper}>
                {icon && <div className={styles.iconWrapper}>{icon}</div>}
                <Input
                    ref={ref}
                    disabled={disabled}
                    className={`${icon ? styles.inputWithIcon : ''} ${iconRight ? styles.inputWithIconRight : ''}`}
                    {...inputProps}
                    error={!!error} // Pass true if error exists
                />
                {iconRight && <div className={styles.iconRightWrapper}>{iconRight}</div>}
            </div>
            {error && <span className={styles.errorMessage}>{error}</span>}
        </label>
    );
});

InputWithLabel.displayName = 'InputWithLabel';

export default InputWithLabel;
